export const situationsTwo = [
  {
    id: 1,
    text: "You are an unemployed commerce graduate. After a long search, you receive an offer from a private company for the job of sales manager, but the company wants a surety of deposit Rs 20,000/- in cash. You don't have much money. You...",
    response:
      "Asked help from relatives and returned money from the first salary.",
  },
  {
    id: 2,
    text: "A friend of yours who had gone to England is about to return. He has written to you asking if you need anything from that country. You...",
    response:
      "Asked him to bring a copy of portland vase and wished him happy journey.",
  },
  {
    id: 3,
    text: "A person has moved into your neighborhood only recently. You have just formed your acquaintance with him. One morning he comes to your house, shows a telegram stating that his mother is serious at his native place and asks you for a loan of Rs 5000/-...",
    response: "Gave him the money and prayed for his mother's good health.",
  },
  {
    id: 4,
    text: "You are the president of the college union. VIP invited to inaugurate the College Hostel at 10 AM did not arrive. All guests are waiting. What would you do...",
    response:
      "Inaugurated the hotel from the senior-most professor of the college and enjoyed the event.",
  },
  {
    id: 5,
    text: "You have been selected as a member of a foreign mountaineering expedition, but your college also wants you to lead a similar expedition at the same time....",
    response:
      "Told college about the foreign expedition, got approval for joining it, and appointed someone good at my place.",
  },
  {
    id: 6,
    text: "When discussing a national issue, you gave a point which harms a particular group of friends of some other religion. You...",
    response:
      "Justified for my opinion stating no intention of offending anyone and apologize if any.",
  },
  {
    id: 7,
    text: "Your friends calling you for college strike for failing few classmates at lab exam. You will...",
    response:
      "Told them to file RTI and resort to the right way to approach authority and denied participation on strike.",
  },
  {
    id: 8,
    text: "In college hostel, the food is not served as per the given schedule. You will...",
    response:
      "Complained to mess in-charge and Registrar and got it scheduled.",
  },
  {
    id: 9,
    text: "You and your girlfriend are traveling in a private bus and suddenly the driver and his colleagues started to misbehave with your girlfriend. You...",
    response:
      "Confronted them with co-passengers help and lodge complaint against them and got them arrested.",
  },
  {
    id: 10,
    text: "You have a crush on one of your classmates and your friend gives a better gift than you on her/his birthday. You will...",
    response:
      "Gave him/her a rose, expressed my feelings to him/her and asked him/her out for a date.",
  },
  {
    id: 11,
    text: "As a college representative, you are given the order to motivate students to attend the University Entry Scheme program for Army. You...",
    response:
      "Organized a seminar, called veterans and motivated students to join Army. ",
  },
  {
    id: 12,
    text: "You are in charge of sentry post and you saw a truck fully loaded with hidden materials speeding towards the forest lane. You...",
    response:
      "Informed control room, called for extra security, stopped the truck and got it checked and if found illegal, took legal action.",
  },
  {
    id: 13,
    text: "You are newly posted lieutenant at the border and communal clash breaks at the village. You will...",
    response:
      "Informed unit, deployed extra force, imposed a curfew and spread awareness busting rumors and established peace. ",
  },
  {
    id: 14,
    text: "When you were enjoying a campfire at NCC camp, you saw forest fire started at the forest. You...",
    response:
      "Extinguish the campfire, move to a safe place and inform the authority about it.",
  },
  {
    id: 15,
    text: "While watching cinema, the person nearby continuously spitting pan near your legs and front seat. You will...",
    response: "Confronted him and if not stopped, complained to security.",
  },
  {
    id: 16,
    text: "His mother dies due to cancer at an early age and his father left him with a second marriage. He..",
    response: "He went to grand-parents house and lived there",
  },
  {
    id: 17,
    text: "You get less score in 12th standard and because of this you get a seat in a rural college and as you were from city boys are not friendly with you. You will...",
    response:
      "Made efforts and built up a healthy relationship and enjoyed college life. ",
  },
  {
    id: 18,
    text: "Your son wants to study in international residential school, but you want to join him Sainik school. You will...",
    response:
      "Showed him the adventurous life of a Sainik school and convinced him to join.",
  },
  {
    id: 19,
    text: "You are taking your girlfriend to nearby mountain forest for trekking, it's late in the evening and you both lost your way, she is feeling faint as both were fully Tired. You...",
    response:
      "Drank water, took little rest and found the way using google map.",
  },
  {
    id: 20,
    text: "On the journey to forest trip in the weekend, your friend insists you to aim and shoot a spotted deer. You will...",
    response: "Told them it's illegal and warned not to do any such act.",
  },
  {
    id: 21,
    text: "He saw the Ration NCO while he was selling the sugar illegally. He...",
    response: "He Caught him redhanded and took departmental action.",
  },
  {
    id: 22,
    text: "You are returning from your office at late night and suddenly realizes that you have forgotten your mobile at your desk in the office. You will...",
    response: "Went home and took it in the morning.",
  },
  {
    id: 23,
    text: "When he comes in conflict with others. He...",
    response: "He remained calm and smartly handle the situation.",
  },
  {
    id: 24,
    text: "The friend whom he had helped in passing his examination had teamed up with his opponent in the college elections. He...",
    response:
      "He took it lightly and remained focused on the election and won.",
  },
  {
    id: 25,
    text: "On a very cold day five of them set out for an excursion to the neighboring village. On the way, they met a poor man who was shivering. His friends started teasing the poor man and criticizing the Government. He...",
    response:
      "He confronted them, helped the poor man and made them apologize and realize their mistake.",
  },
  {
    id: 26,
    text: "They had to join the All Indian Scout Rally across the river. Seeing the rising water most of the boy's scouts refused to go across. He, as their leader...",
    response:
      "Told them to keep faith and courage, motivated them and crossed the bridge safely. ",
  },
  {
    id: 27,
    text: "He returned home to find his father dead, his mother fainting away and his brother and sisters weeping helplessly. He...",
    response:
      "Made mother conscious, consoled everyone, called other family members and performed the last rites.",
  },
  {
    id: 28,
    text: "His neighbor was very quarrelsome and he...",
    response:
      "He invited them on dinner, spent time together and removed any grudges and established healthy relationship. ",
  },
  {
    id: 29,
    text: "Most of his friends left their home town during wartime to serve in the forces. He...",
    response: "He also volunteered and joined the force.",
  },
  {
    id: 30,
    text: "The college recreation hall was still under construction when the masons went on strike. The principal called upon the boys for help. For a moment none volunteered. He...",
    response:
      " He talked to masons, got to know grievance, informed authority and helped in negotiations and got work restarted.",
  },
  {
    id: 31,
    text: "They had gone on an All-Indian University Tour and he found that their secretary was mishandling the funds. He...",
    response:
      "He complained to organize, got funds checked and if found discrepancies, took departmental actions.",
  },
  {
    id: 32,
    text: "He happened to go on the railway platform, when a soldier while trying to board the train, slipped and injured himself badly. He...",
    response: "He immediately took him to MCO and provided medical assistance.",
  },
  {
    id: 33,
    text: "In a land dispute his brother was beaten badly by the rich party. He...",
    response:
      "He lodges a complaint to police, fight the case and bring perpetrators to justice..",
  },
  {
    id: 34,
    text: "When he went into the third year he realized that his expenses do not fit into the pocket allowance which his father has given. He...",
    response:
      "He started giving tuitions, cut down unnecessary expenses and managed well.",
  },
  {
    id: 35,
    text: "Once there was Locust raid in the village. He...",
    response:
      "He informed local authority and spread awareness among farmers to protect crops by spraying insecticides and covering vulnerable crops.",
  },
  {
    id: 36,
    text: "The subordinates of Mr. X are unhappy with him because of the incitement by a jealous colleague. Mr. X...",
    response:
      "He remained focused and removed myth when asked by the subordinates.",
  },
  {
    id: 37,
    text: "While out on a scout camp, Mr. X is a member of the guard duty. He has finished his tenure of duty from 10 PM to 12 PM when he comes to know that the next person on duty has fallen ill. He...",
    response: "He took his shift and gave him time to rest.",
  },
  {
    id: 38,
    text: "Mr. X is a student delegate to visit a foreign country where he is asked to carry five representative items of his country. He would carry...",
    response:
      "He took War memorial, Red Fort, Parliament, India Gate and Taj Hotel mementos with himself.",
  },
  {
    id: 39,
    text: "He is awakened by strange voice at mid-night. He...",
    response:
      "He looked out, ascertain security and if found suspicious alerted guards.",
  },
  {
    id: 40,
    text: "Being a forest officer he is posted to an unknown and unpleasant place. He..",
    response: "He joined the duty and performed well.",
  },
  {
    id: 41,
    text: "His neighbor always tries to do something wrong to him. He...",
    response: "He maintained a distance from them and lived a happy life. ",
  },
  {
    id: 42,
    text: "While camping on the bank of the river, he sees a house on fire on the other side of the bank. He...",
    response:
      "He rushed along with friends, called the fire brigade and threw river water to control expansion and helped in evacuation.",
  },
  {
    id: 43,
    text: "He is the leader of an outing party some ten miles from the town. On reaching the spot he finds that one of the members has a severe attack of malaria. He...",
    response:
      "He gave him medical assistance, sent him back to the base and continued outing party.",
  },
  {
    id: 44,
    text: "During the morning stroll he finds a young man with a bag in his hand moving around the water filtering plant suspiciously. He...",
    response: "He alerted the guards and got him checked.",
  },
  {
    id: 45,
    text: "He has been requested by the villagers to kill a man-eater, which has caused several deaths. He thinks he is not a good firer. He...",
    response: " He informed the police and got him shot dead. ",
  },
  {
    id: 46,
    text: "He is entertaining a friend who likes to monopolize the conversation. He...",
    response: "He let him talk his mind and make him feel good.",
  },
  {
    id: 47,
    text: "When offered something to eat, he declines to take because...",
    response: "He resists eating outside.",
  },
  {
    id: 48,
    text: "You come to know that your best friend is gay. What will you do...",
    response:
      "Supported him emotionally, and helped him confess this to his parents.",
  },
  {
    id: 49,
    text: "His father is transferred to another place. He is happy because...",
    response: " He loves exploring new places and meeting new people.",
  },
  {
    id: 50,
    text: "Ram's friend wanted to teach a lesson to the warden of their hostel for mismanagement of the mess, and they wanted Ram to join them. So he...",
    response:
      "He denied and complained to mess in charge and registrar about mismanagement of mess.",
  },
  {
    id: 51,
    text: "Ram was late for his English Class on two consecutive days and on the third day the teacher did not permit him to enter the class. So he...",
    response:
      "He stated reason for being late and convinced her and attended classes and never repeated it.",
  },
  {
    id: 52,
    text: "Ram had been to his village during the summer vacation. One raining night he was awakened by the shouts of 'DAKU-DAKU-PAKADO-PAKADO'. He wanted to go out but his parents held him back. So he...",
    response: "He stayed at home and informed police about the Daku.",
  },
  {
    id: 53,
    text: "His house was on the bank of a river. During rainy season one evening some houses lying in the low-level areas, collapsed due to flood in the river. Two men were injured. He",
    response:
      "He immediately evacuated people, called an ambulance and hospitalized them and thereafter, helped family is rehabilitation and getting relief fund from the government..",
  },
  {
    id: 54,
    text: "On a Sunday afternoon he was keen to stay at home and to see the television. His friends suggested that they should all go on a cycle trip to a lakeside spot, 15 km away. It is likely to rain. He...",
    response:
      "He told them about the weather forecast and convinced them to stay home and enjoy a movie together.",
  },
  {
    id: 55,
    text: "Ram had arranged a Drama for his school. While the Drama was in progress the lights went off. The audience become restless and started making noises. Some demanded an immediate refund of their tickets. So he...",
    response:
      "He immediately directed the crew to start the generator and continued the drama.",
  },
  {
    id: 56,
    text: "He was trying to organize a Drama for his school. The main artist refused to take part unless his friend was also given an important role. He found that his friend was not suitable for any role. He...",
    response:
      "He talked to the drama teacher, choose another main artist and gave a good performance.",
  },
  {
    id: 57,
    text: "You are in charge of distributing food in a flood-affected area. There was a delay in the distribution of food and people were standing in a long queue. They got agitated and started throwing stones at the organizers. You...",
    response:
      "Calmed them down, assured giving food to everyone, called more members for help and speed up the food distribution.",
  },
  {
    id: 58,
    text: "His class teacher wanted him and a few other boys, at 5 pm on Saturday, for additional classes. His sports teacher also wanted him, on the same day and time, for a selection trial to form a football team. So he...",
    response:
      "He told class teacher about the trial and convinced for additional classes next day.",
  },
  {
    id: 59,
    text: "He is the monitor of class XI. The teacher of a particular period is absent. Students are making noise, disturbing other classes. They are not in a mood to listen when asked to keep quiet. So he...",
    response:
      "He went to the principal, requested her to send substitute teacher and brought class in a disciplined manner.",
  },
  {
    id: 60,
    text: "His friend observed that the Maths teacher was partial in awarding marks to pupils of the own community. They wanted him to accompany them to lead a delegation to the principal. He...",
    response:
      "He accompanies them, got answer-sheet rechecked and if found discrepancies, requested principal to take action.  ",
  },
  {
    id: 60,
    text: "His friend observed that the Maths teacher was partial in awarding marks to pupils of the own community. They wanted him to accompany them to lead a delegation to the principal. He...",
    response:
      "He accompanies them, got answer-sheet rechecked and if found discrepancies, requested principal to take action. ",
  },
];
